// Top-level router. Home (#/ or empty) is the Design 1 landing page; the
// tenant console (the existing App) lives at #/console.
import { useEffect, useState } from "react";
import { App } from "./App";
import { Landing } from "./landing/Landing";
import { WaitlistLanding } from "./landing/WaitlistLanding";

const isWaitlistPreview = import.meta.env.VITE_WAITLIST_PREVIEW === "true";

function currentRoute(): string {
  return window.location.hash.replace(/^#\/?/, "").split("?")[0];
}

export function Root() {
  const [route, setRoute] = useState<string>(currentRoute);

  useEffect(() => {
    const onHash = () => setRoute(currentRoute());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  if (isWaitlistPreview) {
    return <WaitlistLanding />;
  }

  if (route === "console" || route === "app") {
    return <App />;
  }
  return (
    <Landing
      onEnter={() => {
        window.location.hash = "#/console";
      }}
    />
  );
}
